export const deTranslation = {
  header: {
    homeProjectors: "Heimkino-Projektoren",
    portableProjectors: "Tragbare Projektoren",
    support: "Support",
    promotion: "Angebot",
    dropdownHome: "Heimkino-Projektormodelle und Zubehör",
    dropdownPortable: "Tragbare Projektormodelle und Powerbanks",
    dropdownSupport: "FAQ, Handbücher und Kontaktinformationen",
  },
  main: {
    fastSelfHelpSupport: "Schnelle Selbsthilfe",
    card1: {
      title: "Fragen vor dem Kauf",
      description: "Wie kaufe ich mit einem großen Rabatt?",
      link: "Mehr erfahren",
    },
    card2: {
      title: "Produkt-Support",
      description: "Haben Sie Probleme mit Ihrem Projektor?",
      link: "Wählen Sie Ihr Modell",
    },
    card3: {
      title: "Kundendienst",
      description: "Garantie, Rückgabe, Umtauschrichtlinien",
      link: "Mehr erfahren",
    },
    getSupport: {
      title: "Holen Sie sich Unterstützung von uns",
      replyTime: "Wir antworten normalerweise innerhalb eines Werktages.",
      checkFaq:
        "Bei Geräteproblemen überprüfen Sie bitte zuerst das {faqLink}",
    },
  },
  form: {
    name: "Name",
    email: "E-Mail",
    order_id: "Ihre Bestellnummer",
    orderNumberHelp: "Wie finde ich meine Bestellnummer?",
    describeIssue: "Bitte beschreiben Sie das Problem",
    descriptionHelp:
      "Bitte stellen Sie so viele Fotos und Videos des Fehlers wie möglich zur Verfügung, damit wir die Lösung schnell bestimmen können.",
    fileUpload: "Datei-Upload",
    fileUploadInstructions:
      "{action} Sie Dateien in diesen Bereich, um sie hochzuladen.",
    fileUploadInstructionsAction: "Klicken oder ziehen",
    fileUploadLimit: "Sie können bis zu 5 Dateien hochladen.",
    filesSelected: "{{count}}/5 Dateien ausgewählt.",
    maxFilesError: "Sie können maximal 5 Dateien hochladen.",
    surveyTitle:
      "Eine kleine Umfrage - Welche Upgrades wünschen Sie sich für Ihren nächsten Projektor?",
    surveyPlaceholder: "z.B.: Ich möchte, dass er heller ist, lauter ist, usw.",
    submit: "Senden",
    nextButton: "Weiter",
    previousButton: "Zurück",
    submitSuccess:
      "Support-Ticket gesendet! Wir werden uns bald bei Ihnen melden.",
    step2: {
      expectation: {
        label: "Erfüllt es Ihre Erwartungen?",
        optionYes: "Ja, es funktioniert gut",
        optionNo: "Nein, es hat Probleme",
      },
      rating: {
        label: "Wie würden Sie es bewerten?",
      },
      features: {
        label:
          "Eine kleine Umfrage - Welche Eigenschaften unserer Produkte ziehen Sie am meisten an?",
        placeholder:
          "Zum Beispiel: Aussehen, erschwinglicher Preis, einzigartiges Design, etc.",
      },
    },
    step3: {
      title: "Bitte fordern Sie Ihr Aktivierungsgeschenk an! Es ist kostenlos!",
      gift1Title: "1 Jahr zusätzliche Garantie",
      gift2Title: "180 Tage kostenloser Ersatz",
      confirmation:
        "Wir senden Ihnen eine Bestätigungs-E-Mail an Ihr Postfach, bitte bestätigen Sie den Empfang in der E-Mail.",
      activateButton: "Jetzt aktivieren",
    },
    step4: {
      title: "Sie haben Ihre Garantie erfolgreich aktiviert!",
      line1:
        "Ich hoffe, Ihnen gefällt das Aktivierungsgeschenk, das wir für Sie vorbereitet haben.",
      line2:
        "Sie haben eine Bestätigungs-E-Mail erhalten. Bitte überprüfen Sie Ihren Posteingang, um Ihre ausgewählten Vorteile zu bestätigen.",
      line3:
        "Wenn Sie sie nicht finden können, überprüfen Sie Ihren Spam-Ordner.",
    },
    errors: {
      nameRequired: "Name ist erforderlich.",
      emailRequired: "E-Mail ist erforderlich.",
      emailInvalid: "E-Mail ist ungültig.",
      order_idRequired: "Bestellnummer ist erforderlich.",
      order_idInvalid:
        "Ungültiges Bestellnummernformat (z.B. XXX-XXXXXXX-XXXXXXX).",
      commentRequired: "Bitte beschreiben Sie das Problem.",
      filesRequired: "Mindestens eine Datei ist erforderlich.",
      surveyRequired: "Das Umfragefeld ist ein Pflichtfeld.",
      expectationRequired: "Bitte wählen Sie eine Option.",
      ratingRequired: "Bitte geben Sie eine Bewertung ab.",
      featuresRequired: "Dieses Umfragefeld ist ein Pflichtfeld.",
      giftRequired: "Bitte wählen Sie ein Geschenk zum Aktivieren aus.",
    },
  },
  footer: {
    newsletterTitle: "Abonnieren Sie unseren Newsletter",
    newsletterDescription:
      "Melden Sie sich für unseren Newsletter an, um maßgeschneiderte Produktneuigkeiten, Updates und besondere Einladungen zu erhalten",
    emailPlaceholder: "E-Mail-Adresse",
    signUp: "Anmelden",
    products: "Produkte",
    support: "Support",
    contactUs: "Kontaktieren Sie uns",
    preSales: "Fragen vor dem Kauf",
    productSupport: "Produkt-Support",
    afterSales: "Kundendienst",
    contactInfo: "Kontaktinformationen",
    workingHours: "(CST): Mo-So 9-19 Uhr",
  },
};
